







































	import {Emit} from "vue-property-decorator";
	import {InOut} from 'vue-inout-prop-decorator';
	import {Component, Vue} from '@/shared/component';

	import {AvisLoyer} from '@/models';

	import storeAvisLoyer from "@/stores/modules/avisLoyer";
	import CrudAvisLoyerEditLocation from "@/components/Crud/AvisLoyer/EditCorrespondance.vue";

	@Component({
		components: {
			CrudAvisLoyerEditLocation,
		}
	})
	export default class CrudAvisLoyerEditLocationDialog extends Vue {
		@InOut({ type: AvisLoyer  , isVModel: true }) private value!: AvisLoyer;

		@Emit()
		private onSubmit(avisLoyer: AvisLoyer) {
			this.onClose();
		}

		@Emit()
		private async onClose(): Promise<void> {
			this.value = null;
		}

}
